import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
    HiOutlineHome,
    HiOutlineBriefcase,
    HiOutlineSearch,
    HiOutlineChatAlt2,
    HiOutlineCog,
    HiOutlineBell,
    HiOutlineUser,
    HiOutlineLink,
    HiOutlineArrowUp,
    HiX
} from "react-icons/hi";
import { FaYoutube, FaTiktok, FaFacebookF, FaSnapchatGhost, FaLinkedinIn, FaTwitch } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6"; // Standard X icon

const BrandSettings = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("account"); // account, linked, plan
    const [modalConfig, setModalConfig] = useState(null); // { type: 'email-step1' | 'email-step2' | 'password' }

    const handleLogout = () => {
        // Clear auth tokens/data
        localStorage.clear();
        sessionStorage.clear();
        // Redirect to login
        navigate('/login');
    };

    return (
        <div className="flex h-screen bg-[#FDFBF7]">
            {/* Main Navigation Sidebar */}
            <aside className="w-64 bg-white border-r border-gray-100 flex flex-col hidden md:flex shrink-0 z-20">
                <div className="p-6 flex items-center gap-2 text-black font-bold text-xl">
                    <img src="/logo.png" alt="Braccet" className="w-8 h-8 object-contain" />
                    <span>Braccet</span>
                </div>

                <nav className="flex-1 px-4 py-6 space-y-2">
                    <NavItem to="/brand/dashboard" icon={<HiOutlineHome />} label="Overview" />
                    <NavItem to="/brand/campaigns" icon={<HiOutlineBriefcase />} label="Campaigns" />
                    <NavItem to="/brand/search" icon={<HiOutlineSearch />} label="Find Creators" />
                    <NavItem to="/brand/messages" icon={<HiOutlineChatAlt2 />} label="Messages" />
                    <NavItem to="/brand/settings" icon={<HiOutlineCog />} label="Settings" active />
                </nav>

                <div className="p-4 border-t border-gray-100">
                    <div className="flex items-center gap-3 p-2 rounded-xl hover:bg-gray-50 cursor-pointer">
                        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold">
                            B
                        </div>
                        <div>
                            <p className="text-sm font-bold text-gray-900">Brand Name</p>
                            <p className="text-xs text-gray-500">brand@example.com</p>
                        </div>
                    </div>
                </div>
            </aside>

            {/* Main Content Area */}
            <main className="flex-1 flex flex-col h-screen min-w-0 bg-[#FDFBF7]">
                
                {/* Top Header */}
                <header className="bg-white/80 backdrop-blur-md border-b border-gray-100 px-6 py-3 flex justify-end items-center shrink-0 z-10 h-16">
                    <div className="flex items-center gap-4">
                        <div className="flex items-center gap-2">
                            <HiOutlineBell className="text-xl text-gray-600" />
                            <span className="text-sm font-bold">Johan Doe</span>
                        </div>
                        <div className="w-8 h-8 bg-[#0044CC] rounded-full"></div>
                    </div>
                </header>

                {/* Inner Settings Container */}
                <div className="flex-1 p-6 overflow-hidden flex flex-col min-h-0">
                    <div className="flex-1 bg-white rounded-3xl shadow-sm border border-gray-100 flex overflow-hidden min-h-0">
                        
                        {/* Settings Internal Sidebar */}
                        <div className="w-72 bg-[#f8f9fc] border-r border-gray-100 p-6 flex flex-col shrink-0">
                            <div className="mb-8">
                                <h3 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4">Account</h3>
                                <div className="flex items-center gap-3 mb-6">
                                    <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                                        <img src="https://i.pravatar.cc/150?u=kamran" alt="kamran Razvi" className="w-full h-full object-cover" />
                                    </div>
                                    <div className="min-w-0">
                                        <h4 className="font-bold text-gray-900 text-sm truncate">kamran Razvi</h4>
                                        <p className="text-xs text-gray-500 truncate">Kamran5kr7@gmail.com</p>
                                    </div>
                                </div>
                            </div>

                            <nav className="space-y-1">
                                <button
                                    onClick={() => setActiveTab('account')}
                                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-bold transition-colors text-left
                                        ${activeTab === 'account' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:bg-gray-100'}
                                    `}
                                >
                                    <HiOutlineUser className="text-lg" />
                                    My account
                                </button>
                                <button
                                    onClick={() => setActiveTab('linked')}
                                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-bold transition-colors text-left
                                        ${activeTab === 'linked' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:bg-gray-100'}
                                    `}
                                >
                                    <HiOutlineLink className="text-lg" />
                                    Linked accounts
                                </button>
                                <button
                                    onClick={() => setActiveTab('plan')}
                                    className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-bold transition-colors text-left
                                        ${activeTab === 'plan' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:bg-gray-100'}
                                    `}
                                >
                                    <HiOutlineArrowUp className="text-lg" />
                                    Upgrade Plan
                                </button>
                            </nav>
                        </div>

                        {/* Settings Content Area */}
                        <div className="flex-1 overflow-y-auto p-10 custom-scrollbar">
                            
                            {/* TAB: My Account */}
                            {activeTab === 'account' && (
                                <div className="max-w-2xl">
                                    <h2 className="text-xl font-bold text-gray-900 mb-8">My profile</h2>
                                    
                                    <div className="flex gap-8 mb-12">
                                        <div className="shrink-0 relative">
                                            <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-white shadow-sm bg-gray-100">
                                                <img src="https://i.pravatar.cc/150?u=kamran" alt="Profile" className="w-full h-full object-cover" />
                                            </div>
                                        </div>
                                        <div className="flex-1 space-y-6">
                                            <div>
                                                <label className="block text-xs font-bold text-gray-400 mb-2">Preferred name</label>
                                                <input 
                                                    type="text" 
                                                    defaultValue="Kamran Razvi"
                                                    className="w-full bg-gray-50 border border-gray-100 text-gray-900 text-sm font-medium rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-100"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-xs font-bold text-gray-400 mb-2">Preferred username</label>
                                                <input 
                                                    type="text" 
                                                    defaultValue="Kamranrazvii"
                                                    className="w-full bg-gray-50 border border-gray-100 text-gray-900 text-sm font-medium rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-100"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <h2 className="text-xl font-bold text-gray-900 mb-6 border-t border-gray-100 pt-8">Account Security</h2>
                                    
                                    <div className="space-y-6 mb-12 border-b border-gray-100 pb-8">
                                        {/* Email Row */}
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <h4 className="font-bold text-gray-900 text-sm">Email</h4>
                                                <p className="text-gray-500 text-sm">kamran5kr7@gmail.com</p>
                                            </div>
                                            <button 
                                                onClick={() => setModalConfig({ type: 'email-step1' })}
                                                className="px-6 py-2 border border-gray-200 text-sm font-bold text-gray-700 rounded-xl hover:bg-gray-50 transition-colors"
                                            >
                                                Change email
                                            </button>
                                        </div>

                                        {/* Password Row */}
                                        <div className="flex items-center justify-between">
                                            <div>
                                                <h4 className="font-bold text-gray-900 text-sm">Password</h4>
                                                <p className="text-gray-500 text-sm">Set a permanent password to login to your account</p>
                                            </div>
                                            <button 
                                                onClick={() => setModalConfig({ type: 'password' })}
                                                className="px-6 py-2 border border-gray-200 text-sm font-bold text-gray-700 rounded-xl hover:bg-gray-50 transition-colors"
                                            >
                                                Change password
                                            </button>
                                        </div>
                                    </div>

                                    <div className="flex justify-center mt-4">
                                        <button 
                                            onClick={handleLogout}
                                            className="px-12 py-2.5 border border-red-200 text-red-500 text-sm font-bold rounded-xl hover:bg-red-50 transition-colors"
                                        >
                                            Logout
                                        </button>
                                    </div>
                                </div>
                            )}

                            {/* TAB: Linked Accounts */}
                            {activeTab === 'linked' && (
                                <div>
                                    <h2 className="text-xl font-bold text-gray-900 mb-6">Link Accounts</h2>
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                        <SocialCard icon={<FaYoutube className="text-red-600 text-xl" />} name="Youtube" />
                                        <SocialCard icon={<FaTiktok className="text-black text-xl" />} name="Tiktok" />
                                        <SocialCard icon={<FaFacebookF className="text-blue-600 text-xl" />} name="Facebook" />
                                        <SocialCard icon={<FaXTwitter className="text-black text-xl" />} name="X" />
                                        <SocialCard icon={<FaSnapchatGhost className="text-yellow-400 text-xl" />} name="Snapchat" />
                                        <SocialCard icon={<FaLinkedinIn className="text-blue-700 text-xl" />} name="Linkedin" />
                                        <SocialCard icon={<FaTwitch className="text-purple-600 text-xl" />} name="Twitch" />
                                    </div>
                                </div>
                            )}

                            {/* TAB: Upgrade Plan */}
                            {activeTab === 'plan' && (
                                <div className="max-w-5xl">
                                    <h2 className="text-xl font-bold text-gray-900 mb-6">Active plan</h2>
                                    <div className="mb-16 ml-8">
                                        <h3 className="font-bold text-gray-900">Free</h3>
                                        <p className="text-sm text-gray-600 mt-1 max-w-sm">Lorem ipsum dolor sit amet, consectetur adipiscing vel facilisis.</p>
                                        <p className="text-sm text-gray-400 mt-1">$0 per / month</p>
                                    </div>

                                    <h2 className="text-xl font-bold text-gray-900 mb-10">All Plans</h2>
                                    
                                    <div className="grid grid-cols-4 gap-6">
                                        {/* Empty spacer column to push plans to the right like mockup */}
                                        <div className="col-span-1 border-gray-100 border-r hidden md:block"></div>
                                        
                                        {/* Free Plan */}
                                        <div className="pl-4">
                                            <h3 className="font-bold text-gray-900 mb-6">Free</h3>
                                            <p className="text-sm font-bold text-gray-900 mb-8">$0 <span className="text-gray-500 font-normal">per / month</span></p>
                                        </div>

                                        {/* Plus Plan */}
                                        <div className="pl-4">
                                            <div className="flex items-center gap-3 mb-6">
                                                <h3 className="font-bold text-gray-900">Plus</h3>
                                                <span className="text-[10px] font-bold text-blue-600 bg-blue-50 px-2.5 py-1 rounded-full">Popular</span>
                                            </div>
                                            <p className="text-sm font-bold text-gray-900">$10 <span className="text-gray-500 font-normal">per / month</span></p>
                                            <p className="text-xs text-gray-500 mt-1 mb-8">billed annualy</p>
                                            
                                            <p className="text-xs text-gray-400 mb-6">$12 billed monthly</p>
                                            <button className="px-8 py-2.5 bg-[#0044CC] text-white text-sm font-bold rounded-xl hover:bg-blue-700 transition-colors shadow-sm">
                                                Upgrade
                                            </button>
                                        </div>

                                        {/* Premium Plan */}
                                        <div className="pl-4">
                                            <h3 className="font-bold text-gray-900 mb-6">Premium</h3>
                                            <p className="text-sm font-bold text-gray-900">$15 <span className="text-gray-500 font-normal">per / month</span></p>
                                            <p className="text-xs text-gray-500 mt-1 mb-8">billed annualy</p>
                                            
                                            <p className="text-xs text-gray-400 mb-6">$18 billed monthly</p>
                                            <button className="px-8 py-2.5 border border-blue-100 text-[#0044CC] text-sm font-bold rounded-xl hover:bg-blue-50 transition-colors">
                                                Upgrade
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </main>

            {/* MODALS */}
            {modalConfig && (
                <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-2xl w-full max-w-lg shadow-xl relative animate-in fade-in zoom-in duration-200">
                        {modalConfig.type === 'password' && (
                            <button 
                                onClick={() => setModalConfig(null)}
                                className="absolute top-4 right-4 w-8 h-8 bg-[#0044CC] text-white rounded-full flex items-center justify-center hover:bg-blue-700 transition"
                            >
                                <HiX />
                            </button>
                        )}
                        
                        <div className="p-10">
                            {modalConfig.type === 'email-step1' && (
                                <div className="space-y-6">
                                    <div className="text-sm text-gray-600 space-y-2">
                                        <p>Your current email is <span className="font-bold text-gray-900">kamran5kr7@gmail.com</span></p>
                                        <p>Please enter your password.</p>
                                    </div>
                                    <input 
                                        type="password" 
                                        placeholder="Please enter your password." 
                                        className="w-full bg-white border border-gray-200 text-gray-900 text-sm rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-100"
                                    />
                                    <button 
                                        onClick={() => setModalConfig({ type: 'email-step2' })}
                                        className="w-full py-3 bg-[#0044CC] text-white text-sm font-bold rounded-xl hover:bg-blue-700 transition-colors"
                                    >
                                        Continue
                                    </button>
                                </div>
                            )}

                            {modalConfig.type === 'email-step2' && (
                                <div className="space-y-6">
                                    <div className="text-sm text-gray-600 space-y-2">
                                        <p>Your current email is <span className="font-bold text-gray-900">kamran5kr7@gmail.com</span></p>
                                        <p>Please enter your password.</p>
                                    </div>
                                    <input 
                                        type="password" 
                                        value="•••••••••"
                                        readOnly
                                        className="w-full bg-white border border-gray-200 text-gray-900 text-lg tracking-widest rounded-xl px-4 py-2 opacity-70"
                                    />
                                    <p className="text-xs text-gray-500">Please enter a new email and we will send you a verfication code</p>
                                    <input 
                                        type="email" 
                                        placeholder="Enter new email" 
                                        className="w-full bg-white border border-gray-200 text-gray-900 text-sm rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-100"
                                    />
                                    <button 
                                        onClick={() => setModalConfig(null)}
                                        className="w-full py-3 bg-[#0044CC] text-white text-sm font-bold rounded-xl hover:bg-blue-700 transition-colors"
                                    >
                                        Send verfication code
                                    </button>
                                </div>
                            )}

                            {modalConfig.type === 'password' && (
                                <div>
                                    <div className="flex justify-center mb-4">
                                        <div className="border border-gray-900 rounded px-1 py-0.5 text-xs font-bold tracking-widest">****</div>
                                    </div>
                                    <h2 className="text-lg font-bold text-center text-gray-900 mb-2">Change password</h2>
                                    <p className="text-xs text-center text-gray-500 mb-8 max-w-sm mx-auto leading-relaxed">
                                        Use a password at least 15 letter long or at least 8 characters long with both letters and number
                                    </p>
                                    
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs text-gray-600 mb-1.5 ml-1">Enter your current password</label>
                                            <input 
                                                type="password" 
                                                placeholder="Current password" 
                                                className="w-full bg-white border border-gray-200 text-gray-900 text-sm rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-100"
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs text-gray-600 mb-1.5 ml-1">Enter a new password</label>
                                            <input 
                                                type="password" 
                                                placeholder="New password" 
                                                className="w-full bg-white border border-gray-200 text-gray-900 text-sm rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-100"
                                            />
                                        </div>
                                        <div className="pb-4">
                                            <label className="block text-xs text-gray-600 mb-1.5 ml-1">Confirm your new password</label>
                                            <input 
                                                type="password" 
                                                placeholder="Confirm password" 
                                                className="w-full bg-white border border-gray-200 text-gray-900 text-sm rounded-xl px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-blue-100"
                                            />
                                        </div>
                                        <button 
                                            onClick={() => setModalConfig(null)}
                                            className="w-full py-3 bg-[#0044CC] text-white text-sm font-bold rounded-xl hover:bg-blue-700 transition-colors shadow-md"
                                        >
                                            Change password
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* Add an explicit click-away overlay to click out of the Modals without X buttons */}
                    {(modalConfig.type === 'email-step1' || modalConfig.type === 'email-step2') && (
                        <div onClick={() => setModalConfig(null)} className="absolute inset-0 z-[-1]"></div>
                    )}
                </div>
            )}
        </div>
    );
};

// Reusable components
const NavItem = ({ to, icon, label, active }) => (
    <Link to={to} className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-colors ${active ? 'bg-blue-50 text-[#0044CC]' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'}`}>
        <span className="text-xl">{icon}</span>
        {label}
    </Link>
);

const SocialCard = ({ icon, name }) => (
    <div className="bg-[#f8f9fc] p-6 rounded-2xl flex flex-col items-center text-center">
        <div className="w-10 h-10 bg-white shadow-sm rounded-lg flex items-center justify-center mb-4">
            {icon}
        </div>
        <h4 className="font-bold text-sm text-gray-900 mb-2">{name}</h4>
        <p className="text-xs text-gray-500 mb-6 leading-relaxed px-2">Lorem ipsum dolor sit amet, consectetur adipiscing vel facilisis.</p>
        <button className="w-full py-2 border border-gray-200 text-[#0044CC] text-sm font-bold rounded-xl bg-white hover:bg-gray-50 transition-colors">
            Connect
        </button>
    </div>
);

export default BrandSettings;
